import React from "react";
import { useTranslation } from "react-i18next";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fire-safety-tech-5/artifacts/8mm50cav_Olivine%20Logo.jpg";

export default function Logo({ size = 44, showText = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Olivine Global"
        width={size}
        height={size}
        className="rounded-full ring-1 ring-amber-400/40"
        style={{ width: size, height: size, objectFit: "cover" }}
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-display font-extrabold text-white tracking-tight">OLIVINE</div>
          <div className="font-mono-spec text-[10px] text-amber-400/90">GLOBAL · EST 2024</div>
        </div>
      )}
    </div>
  );
}

export { LOGO_URL };
